<!-- <div class="unauthorized-container">
  <h1>Unauthorized</h1>
  <p>You do not have permission to access this page.</p>
  <a [routerLink]="'/'" class="back-link">Go to Home</a>
</div> -->
<div
  class="d-flex align-items-center justify-content-center flex-column error-page vh-50">
  <div class="motif-display-2-light mb-5 pb-2">(o_o)</div>
  <h1 class="motif-h2-default-light mb-2">Unauthorized!</h1>
  <p class="motif-body1-default-light mb-5 pb-2">You do not have permission to access this page.</p>
    <button motifButton color="primary" size="small" [routerLink]="'/'" aria-label="Navigate to Home">
       Navigate to Home
    </button>
</div>